export interface AllegatoListItem {
  id: string
  titolo: string
  categoria: string | null
  note: string | null
  filename: string
  content_type: string
  file_size: number
  created_at: string
}

// Categorie predefinite per documenti personale
export const CATEGORIE_DOCUMENTI_PERSONALE = [
  { value: 'contratto', label: 'Contratto' },
  { value: 'unilav', label: 'UniLav' },
  { value: 'formazione', label: 'Formazione' },
  { value: 'attestato_sicurezza', label: 'Attestato Sicurezza' },
  { value: 'curriculum', label: 'Curriculum' },
  { value: 'sistema_qualita', label: 'Sistema Qualità' },
  { value: 'documento_identita', label: 'Documento Identità' },
  { value: 'idoneita_sanitaria', label: 'Idoneità Sanitaria' },
  { value: 'altro', label: 'Altro' },
] as const
